<template>
  <div :style="`background:${Color};`" class="sectionColor ">
    <div class="SectionCon content-container">
      <div :style="`min-height: ${Height};`" class="titleandming">
        <div>
          <slot name="left" />
        </div>
        <div>
          <slot name="right" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    color: String,
    height: String
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.sectionColor {
  .SectionCon {
    margin: 0 auto;
  }

  .titleandming {
    display: flex;

    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap-reverse;

    > div {
      width: 50%;
    }
    > div:nth-child(2) {
      text-align: center;
    }
  }
}

@media (max-width: 500px) {
  .sectionColor {
    .titleandming {
      > div {
        width: 100%;
      }
    }
  }
}
</style>
